import type { ReactNode } from "react";

// A single figure card (Income received, Total outgoings, …) from the designs.
export default function StatCard({
  label,
  value,
  sub,
  accent,
  tone,
  icon,
}: {
  label: string;
  value: string;
  sub?: string;
  accent?: boolean;
  tone?: "positive" | "negative";
  icon?: ReactNode;
}) {
  return (
    <div className={"stat-card" + (accent ? " stat-card--accent" : "")}>
      <div className="stat-card__top">
        <p className="stat-card__label">{label}</p>
        {icon && <span className="stat-card__icon" aria-hidden="true">{icon}</span>}
      </div>
      <p className={"stat-card__value" + (tone ? ` stat-card__value--${tone}` : "")}>
        {value}
      </p>
      {sub && <p className="stat-card__sub">{sub}</p>}
    </div>
  );
}
